import { render, staticRenderFns } from "./Hucha.vue?vue&type=template&id=9ce0cbfc&scoped=true"
import script from "./Hucha.vue?vue&type=script&lang=js"
export * from "./Hucha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce0cbfc",
  null
  
)

export default component.exports